import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';
import { DataObjectRelationsGraphDto } from '../types';
import { DataObjectRelationsGraphDtoSchema } from '../schema/DataObjectRelationsGraphDtoSchema';

const getDataObjectRelationsGraph = (filters: any) =>
  apiClient
    .get<DataObjectRelationsGraphDto>(
      expand(DataObjectUrl.RELATIONS_GRAPH, filters),
    )
    .then((response) => DataObjectRelationsGraphDtoSchema.parse(response.data));

export const useGetDataObjectRelationsGraph = createApiQueryHook(
  ['data-object-relations-graph'],
  getDataObjectRelationsGraph,
);
